import { useHistory } from 'react-router';
import { Spinner } from '../../components/common';
import { ROUTE_PATH } from '../../routes/paths';
import Header from '../../components/common/global-top-bar';
import { connect, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { fetchTosRequest, updateTosRequest } from './text-blocks-redux/actions';
import RichTextEditor from '../../components/rich-text-editor/rich-text-editor';
import { Location } from 'history';
import { TextBlocksHeaderOptions } from './common/text-blocks-constants';
import SwitchBar from '../../components/switch-bar';

import RouteLeavingGuard from '../../components/route-leaving-prompt';

type props = {
  pending: boolean;
  clientAdmin: any;
};

const ClientAdminTOS: React.FunctionComponent<props> = ({ pending, clientAdmin }): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [clientAdminToS, setClientAdminToS] = useState<string>('');
  const [needSave, setNeedSave] = useState(true);

  const handleSave = (messageType: string, data: any) => {
    const payload = {
      type: messageType,
      payload: {
        value: data,
      },
    };
    dispatch(updateTosRequest(payload));
  };

  useEffect(() => {
    if (clientAdmin?.status === 200) {
      setClientAdminToS(clientAdmin.data?.CLIENT_ADMIN_TERMS_OF_SERVICE);
      setNeedSave(true);
    }
  }, [clientAdmin]);

  useEffect(() => {
    dispatch(fetchTosRequest({ type: 'CLIENT_ADMIN_TERMS_OF_SERVICE' }));
  }, []);

  return (
    <div>
      {pending && <Spinner />}
      <RouteLeavingGuard
        when={!needSave}
        navigate={(path: string) => history.push(path)}
        shouldBlockNavigation={(location: Location) => {
          if (!needSave) {
            if (location.pathname !== ROUTE_PATH.CLIENTADMINTOC) {
              return true;
            }
          }
          return false;
        }}
        titleText={'Alert'}
        contentText={'You have unsaved changes. Do you want to leave this page and lose your changes?'}
        cancelButtonText={'Cancel'}
        confirmButtonText={'Continue and lose changes'}
      />
      <Header heading={'Client Administrators '} />
      <SwitchBar heading={TextBlocksHeaderOptions} position={1} />

      <div className="max-window-height overflow-y-auto pb-32 pt-4">
        <div>
          <div className="mt-4 w-full px-7">
            <div className="flex items-end justify-between border-b border-gray-500 py-2">
              <p className="text-gray-dark pt-4 font-bold">CLIENT ADMIN TERMS OF SERVICE</p>
              <button
                className="stacked-bar-blue-400 h-6 rounded-full px-2 text-center text-sm text-white disabled:bg-gray-400"
                onClick={() => {
                  handleSave('CLIENT_ADMIN_TERMS_OF_SERVICE', clientAdminToS);
                }}
                disabled={needSave}
              >
                SAVE
              </button>
            </div>
            <div className="mt-4">
              <RichTextEditor
                content={clientAdminToS}
                onChange={(value) => setClientAdminToS(value)}
                key={`client-admin-tos`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    pending: state.Tos?.pending || null,
    clientAdmin: state.Tos.clientAdmin || null,
  };
};

export default connect(mapStateToProps)(ClientAdminTOS);
